import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActionArea } from "@mui/material";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { CardActions } from "@mui/material";
import { Link } from "@mui/material";


export const CheckoutMainCard = () => {
  const data = [
    {
      id: "1",
      title: "Baked Fish Fillets with Cheese Sauce",
      description: "3 meal plan selected",
      image: "./images/food1.png",
      number: "2"
      
    },
    
  ];
  return (
    <>
      <Box component='container'
        sx={{
          mt: "30px",
          display: "flex", flexDirection: "row",
        //    marginTop: "24px"
        }}
      >
        <Grid container spacing={4}>
          {data.map((v, i) => {
            return (
              <>


        <Box
          // ml="24px"
          sx={{ display: "flex", flexDirection: "row", marginTop: "24px" }}
        >
          <Box sx={{ width: "140px", height: "159.4px" }}>
            <img src={v.image} alt="" width="100%" />
          </Box>

          <Box ml="24px">
            <Box>
              <Typography
                sx={{
                  fontSize: { lg: "24px", md: "24px", sm: "18px", xs: "16px" },
                  fontWeight: "600",
                }}
              >
                {v.title}
              </Typography>
              <Typography
                sx={{
                  fontSize: { lg: "18px", md: "18px", sm: "16px", xs: "14px" },
                  fontWeight: "400",
                }}
              >
                {v.description}
              </Typography>
            </Box>

            <Box
              sx={{ display: "flex", flexDirection: "row", paddingTop: "30px", alignItems:"center" }}
            >
              <Box>
              <Link component="button"><img src="./images/minusGreen.svg" alt="" width="100%"/></Link>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontSize: {
                      lg: "24px",
                      md: "24px",
                      sm: "20px",
                      xs: "18px",
                    },
                    fontWeight: "600",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                  }}
                >
                  {v.number}
                </Typography>
              </Box>
              <Box>
                <Link component="button"><img src="./images/Frame 787.svg" alt="" width="100%" /></Link>
              </Box>
            </Box>
          </Box>
        </Box>
              </>
            );
          })}
        </Grid>
      </Box>
    </>
  );
};
